import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs.extend(relativeTime);

export const formatTimeZone = (
  date, 
  timezone = 'America/Lima', 
  format = 'HH:mm a'
) => { 
  const dateObject = dayjs.utc(date).tz(timezone);
  return dateObject.format(format);
};


export const formatRelativeDateTimezone = (
  date,
  timezone = 'America/Lima'
) => {
  const today = dayjs().tz(timezone)

  const dateCurrent = dayjs(date)

  if (dateCurrent.isSame(today, 'day')) {
    return 'Hoy'
  }

  if (dateCurrent.isSame(today.subtract(1, 'day'), 'day')) {
    return 'Ayer'
  }

  if (dateCurrent.isSame(today.subtract(2, 'day'), 'day')) {
    return 'Anteayer'
  }

  if (dateCurrent.isSame(today, 'week')) {
    return dateCurrent.format('dddd')
  }

  return dateCurrent.format('D [de] MMMM [de] YYYY')
};